<template>
  <div class="settings-page">
    <el-card class="settings-heading glass-card" shadow="never">
      <el-avatar class="heading-avatar" :size="45" :src="avatarUrl" icon="el-icon-user-solid"></el-avatar>
      <div>
        <span class="section-kicker">ACCOUNT SETTINGS</span>
        <h1>个人中心</h1>
      </div>
    </el-card>

    <div class="settings-layout">
      <el-card class="settings-sidebar glass-card" shadow="never">
        <div class="sidebar-title">设置菜单</div>
        <div class="settings-nav" role="navigation" aria-label="个人中心菜单">
          <el-button v-for="item in menuItems" :key="item.key" type="text" :class="{ active: activeMenu === item.key }" @click="selectMenu(item.key)">
            <i :class="item.icon"></i><span>{{ item.label }}</span>
          </el-button>
        </div>
      </el-card>

      <el-card class="settings-detail glass-card" shadow="never">
        <div class="detail-heading">
          <div>
            <span class="section-kicker">{{ currentItem.eyebrow }}</span>
            <h2>{{ currentItem.label }}</h2>
          </div>
          <i :class="currentItem.icon"></i>
        </div>
        <app-scrollbar ref="detailScroll" class="detail-scroll">
          <keep-alive>
            <component :is="currentItem.component" :col="backgroundCol"></component>
          </keep-alive>
        </app-scrollbar>
      </el-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { EventBus } from '@/EventBus'
import AppScrollbar from '@/components/AppScrollbar.vue'
import UserInfo from '@/components/UserInfo.vue'
import UserBackground from '@/components/UserBackground.vue'
import UserAnnounce from '@/components/UserAnnounce.vue'
import AuthorBlacklist from '@/components/Blacklist.vue'

const menuItems = [
  { key: 'user-info', label: '个人资料', icon: 'el-icon-user', eyebrow: 'PROFILE', component: 'UserInfo' },
  { key: 'background-setting', label: '背景设置', icon: 'el-icon-picture-outline', eyebrow: 'APPEARANCE', component: 'UserBackground' },
  { key: 'announce-follow', label: '预告收藏', icon: 'el-icon-star-off', eyebrow: 'FOLLOWING', component: 'UserAnnounce' },
  { key: 'blacklist', label: '黑名单', icon: 'el-icon-remove-outline', eyebrow: 'FILTERS', component: 'AuthorBlacklist' }
]

export default {
  name: 'UserSetting',
  components: { AppScrollbar, UserInfo, UserBackground, UserAnnounce, AuthorBlacklist },
  data() {
    return { activeMenu: 'user-info', backgroundCol: 2, menuItems, avatarUrl: '' }
  },
  computed: {
    currentItem() { return this.menuItems.find(item => item.key === this.activeMenu) || this.menuItems[0] }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$notify.error({ title: '未登录', message: '请先登录' })
      this.$router.replace('/login')
    }
  },
  mounted() {
    this.updateViewport()
    this.loadAvatar()
    EventBus.$on('changeState', this.loadAvatar)
    window.addEventListener('resize', this.updateViewport)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateViewport)
    EventBus.$off('changeState', this.loadAvatar)
    if (this.avatarUrl) URL.revokeObjectURL(this.avatarUrl)
  },
  methods: {
    async loadAvatar() {
      const token = localStorage.getItem('token')
      if (!token) return
      try {
        const res = await axios.get('/api/user/avatar', {
          headers: { Authorization: 'Bearer ' + token },
          responseType: 'blob'
        })
        const nextUrl = URL.createObjectURL(res.data)
        if (this.avatarUrl) URL.revokeObjectURL(this.avatarUrl)
        this.avatarUrl = nextUrl
      } catch (error) {
        if (this.avatarUrl) URL.revokeObjectURL(this.avatarUrl)
        this.avatarUrl = ''
      }
    },
    updateViewport() {
      const width = window.innerWidth
      this.backgroundCol = width < 768 ? 1 : width < 1200 ? 2 : 3
    },
    selectMenu(index) {
      this.activeMenu = index
      this.$nextTick(() => {
        if (this.$refs.detailScroll) this.$refs.detailScroll.$el.scrollTop = 0
      })
    }
  }
}
</script>

<style scoped>
.settings-page { display: flex; flex-direction: column; gap: 10px; height: 100%; min-height: 0; color: #303133; text-align: left; }
.glass-card { border: 1px solid rgba(220, 223, 230, .8); border-radius: 17px; background: rgba(255, 255, 255, .58); box-shadow: 0 10px 30px rgba(0, 0, 0, .08); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); }
.settings-heading { flex: none; }
.settings-heading >>> .el-card__body { display: flex; align-items: center; gap: 14px; padding: 16px 20px; }
.heading-avatar { flex: none; border: 1px solid rgba(64, 158, 255, .22); background: rgba(64, 158, 255, .13); color: #409eff; }
.section-kicker { color: #409eff; font-size: 10px; font-weight: 800; letter-spacing: .16em; }
.settings-heading h1 { margin: 3px 0 0; font-size: 23px; line-height: 1.2; }
.settings-layout { display: grid; grid-template-columns: 218px minmax(0, 1fr); gap: 10px; flex: 1; min-height: 0; }
.settings-sidebar, .settings-detail { min-height: 0; overflow: hidden; }
.settings-sidebar >>> .el-card__body { padding: 16px 10px; }
.sidebar-title { padding: 0 12px 10px; color: #909399; font-size: 11px; }
.settings-nav { display: flex; flex-direction: column; gap: 4px; }
.settings-nav >>> .el-button { display: flex; align-items: center; justify-content: flex-start; height: 43px; margin: 0; padding: 0 12px; border-radius: 8px; color: #606266; font-size: 14px; text-align: left; }
.settings-nav >>> .el-button:hover, .settings-nav >>> .el-button:focus { background: rgba(64, 158, 255, .1); }
.settings-nav >>> .el-button.active { background: rgba(64, 158, 255, .14); color: #409eff; font-weight: 700; }
.settings-nav >>> .el-button i { margin-right: 8px; font-size: 16px; }
.settings-detail >>> .el-card__body { display: flex; flex-direction: column; height: 100%; min-height: 0; box-sizing: border-box; padding: 0; }
.detail-heading { display: flex; align-items: center; justify-content: space-between; flex: none; padding: 19px 24px 16px; border-bottom: 1px solid rgba(220, 223, 230, .75); }
.detail-heading h2 { margin: 5px 0 0; font-size: 20px; line-height: 1.2; }
.detail-heading > i { color: #b3d8ff; font-size: 26px; }
.detail-scroll { flex: 1; padding: 20px 24px 28px; }
@media (max-width: 767px) {
  .settings-heading >>> .el-card__body { padding: 12px 14px; }
  .settings-heading h1 { font-size: 20px; }
  .settings-layout { display: flex; flex-direction: column; }
  .settings-sidebar { flex: none; }
  .settings-sidebar >>> .el-card__body { padding: 5px 7px; }
  .sidebar-title { display: none; }
  .settings-nav { flex-direction: row; overflow-x: auto; white-space: nowrap; scrollbar-width: none; }
  .settings-nav::-webkit-scrollbar { display: none; }
  .settings-nav >>> .el-button { flex: 1 0 auto; height: 40px; padding: 0 9px; font-size: 12px; }
  .settings-nav >>> .el-button i { margin-right: 4px; }
  .settings-detail { flex: 1; }
  .detail-heading { padding: 13px 15px; }
  .detail-heading h2 { font-size: 17px; }
  .detail-scroll { padding: 14px 12px 20px; }
}
</style>
